import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration - using unified SSO project (executive-force-ai-453011)
// These are PUBLIC frontend credentials - safe to include in client-side code
// See: https://firebase.google.com/docs/projects/api-keys
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyDzSVcepxdliuW-nM026lRmopvg324Q-XY",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "executive-force-ai-453011.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "executive-force-ai-453011",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "executive-force-ai-453011.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "327026071945",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:327026071945:web:17e73a735d4ac4cc25a958",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || undefined,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app;

